import { StorageError } from './errors.js';
export function pendingMigrations(currentVersion, migrations) {
    if (!Number.isSafeInteger(currentVersion) || currentVersion < 0) {
        throw new StorageError('invalid-data', { detail: 'Current schema version is invalid' });
    }
    let previousVersion = 0;
    const names = new Set();
    for (const migration of migrations) {
        if (!Number.isSafeInteger(migration.version) || migration.version < 1) {
            throw new StorageError('invalid-data', { detail: 'Migration versions must be positive integers' });
        }
        if (migration.version <= previousVersion) {
            throw new StorageError('invalid-data', { detail: 'Migrations must be strictly ordered by version' });
        }
        if (names.has(migration.name))
            throw new StorageError('invalid-data', { detail: 'Migration names must be unique' });
        names.add(migration.name);
        previousVersion = migration.version;
    }
    const pending = migrations.filter((migration) => migration.version > currentVersion);
    let expectedVersion = currentVersion + 1;
    for (const migration of pending) {
        if (migration.version !== expectedVersion) {
            throw new StorageError('invalid-data', {
                detail: `Missing migration from version ${expectedVersion - 1} to ${expectedVersion}`,
            });
        }
        expectedVersion += 1;
    }
    return pending;
}
//# sourceMappingURL=migrations.js.map